import React from 'react';

const styles = {
  container: {
    maxWidth: '700px',
    margin: '40px auto',
    padding: '25px',
    borderRadius: '12px',
    backgroundColor: '#f4fff4',
    border: '2px solid #008000',
    boxShadow: '0 6px 15px rgba(0, 128, 0, 0.2)',
    fontFamily: 'Segoe UI, sans-serif',
    color: '#003300',
    lineHeight: 1.6
  },
  header: {
    textAlign: 'center',
    fontSize: '30px',
    fontWeight: 'bold',
    color: '#008000',
    marginBottom: '20px'
  },
  subHeader: {
    fontSize: '22px',
    color: '#006400',
    margin: '15px 0 10px'
  },
  paragraph: {
    fontSize: '16px',
    marginBottom: '15px'
  },
  list: {
    paddingLeft: '20px',
    marginBottom: '15px'
  },
  listItem: {
    marginBottom: '8px'
  }
};

const FiftySeaterBus = () => {
  return (
    <>
      <section
        className="page-title"
        style={{ backgroundImage: 'url(images/background/3.jpg)' }}
      >
        <div className="auto-container">
          <h1>50-Seater Bus Rental</h1>
          <div className="bread-crumb-outer"></div>
        </div>
      </section>

      <div style={styles.container}>
        <h1 style={styles.header}>50-Seater Bus Rentals by eTravo</h1>

        <p style={styles.paragraph}>
          Need to move a large group in comfort and safety? <strong>eTravo</strong> offers well-maintained, 
          chauffeur-driven 50-seater buses perfect for corporate events, school trips, weddings, pilgrimages, 
          and sightseeing tours. Our buses ensure a smooth journey backed by professional service and expert drivers.
        </p>

        <h2 style={styles.subHeader}>Ideal For:</h2>
        <ul style={styles.list}>
          <li style={styles.listItem}>Corporate Group Travel</li>
          <li style={styles.listItem}>Marriage Guest Transport</li>
          <li style={styles.listItem}>School & College Excursions</li>
          <li style={styles.listItem}>Pilgrimage or Temple Tours</li>
          <li style={styles.listItem}>Long-Distance Trips & Sightseeing</li>
        </ul>

        <h2 style={styles.subHeader}>Key Features of Our Buses:</h2>
        <ul style={styles.list}>
          <li style={styles.listItem}>Comfortable push-back seats (50 passengers)</li>
          <li style={styles.listItem}>Fully Air Conditioned (optional non-AC available)</li>
          <li style={styles.listItem}>Ample luggage space & overhead storage</li>
          <li style={styles.listItem}>Curtains, footrests, reading lights</li>
          <li style={styles.listItem}>Mic and music system for onboard announcements</li>
          <li style={styles.listItem}>Well-trained and uniformed drivers & staff</li>
        </ul>

        <h2 style={styles.subHeader}>Why Choose eTravo?</h2>
        <p style={styles.paragraph}>
          With years of experience in group transport, <strong>eTravo</strong> is known for reliability,
          transparent pricing, and excellent fleet quality. We sanitize all buses before each trip and follow 
          safety norms. You get 24x7 customer support, GPS tracking (on select vehicles), and seamless coordination 
          from booking to drop-off.
        </p>

       

        <h2 style={styles.subHeader}>Book Your Bus Now</h2>
        <p style={styles.paragraph}>
          Whether you're planning a wedding, school trip, or a business outing, <strong>eTravo</strong> 
          ensures your large group travels together in comfort. Contact us today for a free quote and 
          immediate confirmation!
        </p>
      </div>
    </>
  );
};

export default FiftySeaterBus;
